import { TemplateWithOverlay } from './TemplateWithOverlay';

export default TemplateWithOverlay;